import { useQuery } from '@tanstack/react-query';
import { axios } from '../../config/axios';
import { QUERY_KEYS } from '../../constants/queryKeys.const';
import { Config } from '../../types/react-query.types';
import { GroupedMessages } from '../../types/messages.types';

export const useUnseenNotifications = (userId: number, config: Config = {}) => {
  return useQuery(
    [QUERY_KEYS.GET_UNSEEN_NOTIFICATIONS],
    async (): Promise<GroupedMessages> => {
      return axios.get(`notifications/unseen/${userId}`);
    },
    config,
  );
};
